// @flow

import React from 'react';
import ReactDOM from 'react-dom';

import { SavedFundingMethodController } from './saved-funding-method';
import { Controller } from './controller';
import { PublicEventBusContext, PublicEventBus } from './public-event-bus';

export class Tectonics {
  actionOrHash: ?string;
  lookAndFeelCode: ?string;
  tenant: ?string;

  bus = new PublicEventBus();
  el = document.createElement('section');

  constructor(actionOrHash?: string, lookAndFeelCode?: string, tenant?: string) {
    this.actionOrHash = actionOrHash;
    this.lookAndFeelCode = lookAndFeelCode;
    this.tenant = tenant;
    this.renderRoot();
  }

  renderRoot() {
    if (!this.actionOrHash) {
      throw new Error('Tectonics - missing action or hash');
    }

    if (this.actionOrHash.startsWith('saved-funding-method')) {
      this.renderSavedFundingMethodRoot();
    } else {
      this.renderPaymentPageRoot();
    }
  }

  renderSavedFundingMethodRoot() {
    const action = ((this.actionOrHash: any): string);

    ReactDOM.render(
      <SavedFundingMethodController
        action={action}
        tenantCode={this.tenant}
        lookAndFeelCode={this.lookAndFeelCode}
      />,
      this.el,
    );
  }

  renderPaymentPageRoot() {
    const hash = ((this.actionOrHash: any): string);

    ReactDOM.render(
      <PublicEventBusContext.Provider value={this.bus}>
        <Controller
          hash={hash}
          lookAndFeelCode={this.lookAndFeelCode || undefined}
          localTenancy={this.tenant || undefined}
        />
      </PublicEventBusContext.Provider>,
      this.el
    );
  }

  renderTo(root: HTMLDivElement) {
    const { el } = this;
    if (el.parentElement !== root) {
      root.appendChild(el);
    }
  }

  destroy() {
    const { el } = this;
    el.remove();
    ReactDOM.unmountComponentAtNode(el);
  }

  on = this.bus.on.bind(this.bus);
  off = this.bus.off.bind(this.bus);
  trigger = this.bus.trigger.bind(this.bus);
}

window.Tectonics = Tectonics;
